import { IPicture } from "../../models";
import { Currency } from "../../common/constants";

export const isBih = (currency: Currency) => currency === "KM";

let lastPictures: IPicture[] | undefined;
let lastCurrency: Currency | undefined;
let lastCatalog: IPicture[] = [];

/**
 * The catalog as the visitor's country sees it (KM = BiH, DIN = Serbia): pictures hidden there
 * are left out, and `status` is that country's stock. Everything that reads `pic.status`
 * (Na stanju / Rezerviši) then works per country unchanged.
 * Memoized on (pictures, currency), so the result is stable between renders.
 */
export const localizePictures = (
  allPictures: IPicture[],
  currency: Currency
): IPicture[] => {
  if (allPictures === lastPictures && currency === lastCurrency) {
    return lastCatalog;
  }
  lastPictures = allPictures;
  lastCurrency = currency;
  // An API from before the BiH columns doesn't send them: fall back to the Serbia values
  lastCatalog = isBih(currency)
    ? allPictures
        .filter((p) => !(p.isDeletedBIH ?? p.isDeleted))
        .map((p) => ({ ...p, status: p.statusBIH ?? p.status }))
    : allPictures.filter((p) => !p.isDeleted);
  return lastCatalog;
};
